import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';

import { setUpdateInstructorsModalState } from 'features/classCreation';
import styles from './UpdateInstructorButton.module.scss';

export default function UpdateInstructorButton({ disabled }) {
  const dispatch = useDispatch();

  const handleUpdate = useCallback(() => {
    dispatch(setUpdateInstructorsModalState(true));
  }, [dispatch]);

  return (
    <Tappable
      className={classNames('btn btn-primary btn-outlined m-r-xs ', {
        [styles.changeInstructorButton]: disabled,
      })}
      onClick={handleUpdate}
      disabled={disabled}
    >
      <Icon
        name="swap-role"
        className="m-r-xxs"
      />
      Change Instructor
    </Tappable>
  );
}
